import React from 'react';
import Text from '@service-victoria/component-library/components/Text';
import RadioButton, {
  ItemType as RadiobuttonItem
} from '@service-victoria/component-library/components/RadioButton';
import { vaxStatusFieldOptions } from 'utils/constants';
import { Spacer16 } from '../../../steps/styled';
import styled from 'styled-components';

const NON_INTERNATIONAL_VAX_STATUS_OPTIONS = [
  vaxStatusFieldOptions.fullyVaccinated,
  vaxStatusFieldOptions.unvaccinatedOrPartial
];

const INTERNATIONAL_VAX_STATUS_OPTIONS = [
  vaxStatusFieldOptions.internationalFullyVaccinated,
  vaxStatusFieldOptions.internationalFullyVaccinatedParentOrGuardian,
  vaxStatusFieldOptions.internationalUnder12
];

const getVaxStatusOptions = (isInternationalArrivalPermit: boolean): RadiobuttonItem[] => {
  const options = isInternationalArrivalPermit
    ? INTERNATIONAL_VAX_STATUS_OPTIONS
    : NON_INTERNATIONAL_VAX_STATUS_OPTIONS;

  return options.map(({ dataTestId, ...option }) => ({
    ...option,
    label: option.value,
    inputProps: {
      'data-testid': dataTestId
    }
  }));
};

const RadioContainer = styled.div`
  label {
    height: auto;
  }
`;

export const VaccinationStatus: React.FC<{ travelZone?: string }> = ({ travelZone }) => {
  const isInternationalPermit = travelZone === 'international';

  return (
    <>
      <Text.Heading.H3 fontWeight={600} id='vaxStatusHeading'>
        Confirm your COVID-19 vaccination status
      </Text.Heading.H3>
      <Spacer16 />
      {(!travelZone || !isInternationalPermit) && (
        <Text.Body>
          The rules you need to follow when entering Victoria depend on your vaccination status.
        </Text.Body>
      )}
      {travelZone && !isInternationalPermit && (
        <>
          <Text.Body>
            If you are not fully vaccinated against COVID-19, or have a medical exemption you may
            have to quarantine for longer on arrival and agree to get regular tests for COVID-19.
          </Text.Body>
          <Text.Body>I am:</Text.Body>
        </>
      )}
      {travelZone && (
        <RadioContainer>
          <RadioButton
            name='assess.vaccinationStatus'
            items={getVaxStatusOptions(isInternationalPermit)}
            aria-labelledby='vaxStatusHeading'
            errorLabelProps={{
              'data-testid': 'VaxStatus-RadioButtonError'
            }}
          />
        </RadioContainer>
      )}
    </>
  );
};
